module.exports = __webpack_public_path__ + "img/product-preview-34.8ad2cfe.png";